import React, { FC } from 'react';
import { ProgressCircle } from '@saucelabs/ds-progress';

/**
 * Displays a loading indicator in the center of the container.
 */
export const FullPageLoader: FC = () => (
  <div className="flex h-full w-full justify-center items-center">
    <ProgressCircle
      size="large"
    />
  </div>
);
